
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b4fs3", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $inPa6 = parcelRequire("inPa6");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500 = 'nav4CollapseReminderSpotlight';
const $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1 = (0, $cgtv4.defineMessages)({
    heading: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.heading",
        defaultMessage: "Want to hide the sidebar?"
    },
    body: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.body",
        defaultMessage: "Select the collapse icon in the top left of your screen. You can expand it again at any time."
    },
    dismissButton: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.dismiss",
        defaultMessage: "OK"
    }
});
const $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2 = (setIsNav4CollapseReminderSpotlightActive)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const dismissSpotlight = ()=>{
        // Fire analytics event
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'done',
                source: $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500
            }
        }).fire();
        // Hide the spotlight
        setIsNav4CollapseReminderSpotlightActive(false);
        // Mark as dismissed in onboarding state
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED),
            value: new Date().toISOString()
        });
    };
    return {
        dismissSpotlight: dismissSpotlight
    };
};
module.exports["NAV_4_COLLAPSE_REMINDER_SOURCE"] = $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500;
module.exports["nav4CollapseReminderI18n"] = $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1;
module.exports["useNav4CollapseReminderDismissal"] = $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2;

});

parcelRegister("JEZ6P", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $hsPNq = parcelRequire("hsPNq");








var $io723 = parcelRequire("io723");


var $8w1c1 = parcelRequire("8w1c1");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $hAiCi = parcelRequire("hAiCi");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $5izcQ = parcelRequire("5izcQ");


var $8zs3p = parcelRequire("8zs3p");


var $e1eDr = parcelRequire("e1eDr");

/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");





var $fFa3V = parcelRequire("fFa3V");


var $inPa6 = parcelRequire("inPa6");


var $3uA7H = parcelRequire("3uA7H");


var $cN7t9 = parcelRequire("cN7t9");


var $6UUmP = parcelRequire("6UUmP");





var $aaBfd = parcelRequire("aaBfd");


var $9OYu5 = parcelRequire("9OYu5");


var $huiud = parcelRequire("huiud");


var $5fMbj = parcelRequire("5fMbj");


var $7R2w7 = parcelRequire("7R2w7");


var $622t3 = parcelRequire("622t3");


var $cvtof = parcelRequire("cvtof");

const $31c01975bf558c1d$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $31c01975bf558c1d$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $31c01975bf558c1d$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const isFhsEnabled = (0, $8zs3p.useIsFhsEnabled)();
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $42omo.useContext)((0, $cvtof.SideNavVisibilityState)); // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $42omo.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $42omo.useContext)((0, $5fMbj.SideNavToggleButtonAttachRef)); /**
                                                         * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
                                                         *
                                                         * My theory is that something to do with SSR, hydration and suspense was causing the
                                                         * underlying HTML element to change but without causing the toggle button to remount.
                                                         *
                                                         * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
                                                         */ 
    const [element, setElement] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $42omo.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $42omo.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $fFa3V.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $622t3.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        if (isFhsEnabled) openLayerObserver?.closeLayers();
    }, [
        isFhsEnabled,
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $42omo.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]); /**
                                                  * ## Behaviour
                                                  * It is intentional that collapse icon will be used while the flyout is open.
                                                  * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                  *
                                                  * ## Why a function?
                                                  * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                  * the button will cause the svg element to be replaced, which can trigger a
                                                  * "mouseenter" event. This is problematic when the user is already over the button,
                                                  * as it can result in a "mouseenter" event after the user manually entered the button.
                                                  *
                                                  * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                  * memoize it, or pull it out into a new function
                                                  */ 
    const icon = (props)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uA7H))), {
                ...props
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cN7t9))), {
                ...props
            })
        });
    const isShortcutEnabled = (0, $9OYu5.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $42omo.useMemo)(()=>{
        if (isFhsEnabled) return {
            ...$31c01975bf558c1d$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $huiud.sideNavToggleTooltipKeyboardShortcut) : undefined
        };
        return $31c01975bf558c1d$var$toggleButtonTooltipOptions;
    }, [
        isFhsEnabled,
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};



var $dTIqH = parcelRequire("dTIqH");

var $idPUB = parcelRequire("idPUB");

var $9vGun = parcelRequire("9vGun");











var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");


var $iXCQx = parcelRequire("iXCQx");


var $b4fs3 = parcelRequire("b4fs3");

const $e0356f01208b13d1$export$6cddb4d20889bca4 = ({ children: children, isVisible: isVisible, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { dismissSpotlight: dismissSpotlight } = (0, $b4fs3.useNav4CollapseReminderDismissal)(setIsNav4CollapseReminderSpotlightActive);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isVisible,
        placement: "right-end",
        dismiss: dismissSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "nav4-collapse-reminder-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: dismissSpotlight
    }, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).dismissButton)))))));
};



var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $2VQ4B = parcelRequire("2VQ4B");





var $kVysQ = parcelRequire("kVysQ");


var $4NX9d = parcelRequire("4NX9d");


var $de2j9 = parcelRequire("de2j9");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $XLQOT = parcelRequire("XLQOT");


var $9wGTI = parcelRequire("9wGTI");


var $bedQP = parcelRequire("bedQP");


var $c5zvz = parcelRequire("c5zvz");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $78QFu = parcelRequire("78QFu");


var $eBBZq = parcelRequire("eBBZq");


var $1B659 = parcelRequire("1B659");

/* SiteLogoButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $lAFHW = parcelRequire("lAFHW");


var $2rzyy = parcelRequire("2rzyy");

var $iG5N1 = parcelRequire("iG5N1");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $1NBp8 = parcelRequire("1NBp8");


var $gz8ZY = parcelRequire("gz8ZY");


const $760ef9e13b699b30$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("6IkrI"))).fireLogoClickedAnalytics);
const $760ef9e13b699b30$var$customLogo = null;
const $760ef9e13b699b30$export$48df75a983e1f3fb = ({ siteConfiguration: siteConfiguration, siteSettings: siteSettings, siteDescription: siteDescription, onLoadCustomLogo: onLoadCustomLogo })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = $760ef9e13b699b30$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    const siteTitle = siteSettings && siteSettings.siteTitle;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const CustomNavLogo = (0, $42omo.useMemo)(()=>{
        if (siteConfiguration?.customSiteLogo && siteDescription?.logoUrl) {
            if (isNav4Enabled) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl ?? undefined,
                    onLoad: onLoadCustomLogo
                });
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl ?? undefined,
                    onLoad: onLoadCustomLogo,
                    className: (0, $gMc0m.default)([
                        "_1bsb1f4h _4t3i1f4h"
                    ])
                });
        }
        return null;
    }, [
        isNav4Enabled,
        onLoadCustomLogo,
        siteConfiguration?.customSiteLogo,
        siteDescription?.logoUrl
    ]);
    return CustomNavLogo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iG5N1.CustomLogo), {
        label: siteTitle ?? 'Confluence',
        logo: CustomNavLogo,
        icon: CustomNavLogo,
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2rzyy.AppLogo), {
        label: siteTitle ?? 'Confluence',
        icon: (0, $lAFHW.ConfluenceIcon),
        name: "Confluence",
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    });
};





/**
 * @generated SignedSource<<1baf4a6dbb28d17b6d189331decbba53>>
 * @relayHash 07605b0f94d6bfbf5c86ce6f43ee8794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e
const $4442fad673926b38$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v1 = {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ]
        },
        "params": {
            "cacheID": "07605b0f94d6bfbf5c86ce6f43ee8794",
            "id": "be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e",
            "metadata": {},
            "name": "HelpButtonQuery",
            "operationKind": "query",
            "text": "query HelpButtonQuery{user:confluence_atlassianUser(current:true){emails{value},id}}"
        }
    };
}();
$4442fad673926b38$var$node.hash = "ea68606a14f00f692f5d23a208b10f51";
var $4442fad673926b38$export$2e2bcd8739ae039 = $4442fad673926b38$var$node;














var $6xdDU = parcelRequire("6xdDU");


var $hOWPZ = parcelRequire("hOWPZ");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");


var $14QAi = parcelRequire("14QAi");


var $dIDyF = parcelRequire("dIDyF");


var $56QzY = parcelRequire("56QzY");





var $1kHsc = parcelRequire("1kHsc");





var $6GD8y = parcelRequire("6GD8y");





var $bQIml = parcelRequire("bQIml");


var $5a7m4 = parcelRequire("5a7m4");


var $efvKr = parcelRequire("efvKr");








var $3fBqY = parcelRequire("3fBqY");


var $8aF6s = parcelRequire("8aF6s");


var $6wrL8 = parcelRequire("6wrL8");

const $48d2632049a03f8d$var$HelpButtonQuery = (0, $4442fad673926b38$export$2e2bcd8739ae039);
const $48d2632049a03f8d$export$78bddedbcf2939ac = ()=>{
    const $ = (0, $frIzR.c)(38);
    const triggerButtonRef = (0, $42omo.useRef)(null);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const inProductHelp = (0, $cLgYq.useInProductHelpActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $8C5kA.default)();
    let t0;
    if ($[0] !== rightSidebarContext) {
        t0 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t0;
    } else t0 = $[1];
    const isHelpPanelOpen = t0 === (0, $dIDyF.HELP_PANEL_ID);
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($48d2632049a03f8d$var$HelpButtonQuery);
    let t2;
    if ($[2] !== data) {
        t2 = (0, $3fBqY.isAtlassianStaff)(data);
        $[2] = data;
        $[3] = t2;
    } else t2 = $[3];
    const isInternalAtlassianUser = t2;
    const [activeDialog, setActiveDialog] = (0, $42omo.useState)(null);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== experienceTracker || $[6] !== inProductHelp || $[7] !== isHelpPanelOpen || $[8] !== rightSidebarContext || $[9] !== routeData.current?.href || $[10] !== routeData.current?.routeName) {
        t3 = ()=>{
            if (isHelpPanelOpen) rightSidebarContext.close((0, $dIDyF.HELP_PANEL_ID));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                    attributes: {
                        navVersion: "4"
                    }
                });
                rightSidebarContext.open((0, $dIDyF.HELP_PANEL_ID), (0, $dIDyF.HELP_PANEL_WIDTH));
                rightSidebarContext.setTriggerButtonRef?.(triggerButtonRef);
                const { routeName: routeName, routeGroup: routeGroup } = (0, $14QAi.getRouteData)(routeData.current?.href || "");
                inProductHelp.setRouteName(routeName);
                inProductHelp.setRouteGroup(routeGroup);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "help",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = experienceTracker;
        $[6] = inProductHelp;
        $[7] = isHelpPanelOpen;
        $[8] = rightSidebarContext;
        $[9] = routeData.current?.href;
        $[10] = routeData.current?.routeName;
        $[11] = t3;
    } else t3 = $[11];
    const onClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setActiveDialog(null);
        };
        $[12] = t4;
    } else t4 = $[12];
    const closeDialog = t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[13] = t5;
    } else t5 = $[13];
    const openDialog = t5;
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>openDialog($48d2632049a03f8d$var$_temp);
        $[14] = t6;
    } else t6 = $[14];
    const openShortcutsDialog = t6;
    let t7;
    if ($[15] !== showModal) {
        t7 = ()=>{
            showModal((0, $6wrL8.DevToolsDialog), {});
        };
        $[15] = showModal;
        $[16] = t7;
    } else t7 = $[16];
    const openDevToolsDialog = t7;
    const preloadMenu = $48d2632049a03f8d$var$_temp2;
    let t8;
    if ($[17] !== intl) {
        t8 = intl.formatMessage($48d2632049a03f8d$var$i18n.help);
        $[17] = intl;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isHelpPanelOpen || $[20] !== onClick || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hOWPZ.Help), {
            onClick: onClick,
            label: t8,
            isSelected: isHelpPanelOpen,
            ref: triggerButtonRef
        }));
        $[19] = isHelpPanelOpen;
        $[20] = onClick;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isLiveEditMode || $[24] !== isOnEditRoute) {
        t10 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_HELP_SHORTCUT) : [
            (0, $gnkil.HELP_SHORTCUT),
            (0, $gnkil.UNIVERSAL_HELP_SHORTCUT)
        ];
        $[23] = isLiveEditMode;
        $[24] = isOnEditRoute;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: t10,
            listener: openShortcutsDialog,
            isAppNavigationShortcut: true
        });
        $[26] = t10;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== isInternalAtlassianUser || $[29] !== openDevToolsDialog) {
        t12 = isInternalAtlassianUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT),
            listener: openDevToolsDialog,
            isAppNavigationShortcut: true,
            allowInDialog: true
        });
        $[28] = isInternalAtlassianUser;
        $[29] = openDevToolsDialog;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== activeDialog) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activeDialog);
        $[31] = activeDialog;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t11, t12, t13);
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t9;
        $[37] = t14;
    } else t14 = $[37];
    return t14;
};
const $48d2632049a03f8d$var$i18n = (0, $cgtv4.defineMessages)({
    help: {
        id: "app-navigation.top-navigation.help",
        defaultMessage: "Help"
    }
});
function $48d2632049a03f8d$var$_temp(onClose) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bQIml.KeyboardShortcutsDialog), {
        onClose: onClose
    });
}
function $48d2632049a03f8d$var$_temp2() {
    (0, $5a7m4.preloadHelpMenu)();
}



var $9MAeh = parcelRequire("9MAeh");










var $gtD4K = parcelRequire("gtD4K");





var $9xVAL = parcelRequire("9xVAL");











var $d9tcB = parcelRequire("d9tcB");








var $mghzX = parcelRequire("mghzX");

const $5f8faa2e47e4a6d0$export$e2457e1974c298c3 = ()=>{
    const $ = (0, $frIzR.c)(7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== push || $[2] !== routeData.current?.routeName) {
        t0 = (e)=>{
            const url = (0, $1NBp8.ADMIN_SETTINGS).toUrl();
            if (e.metaKey) window.open(url, "_blank", "noreferrer");
            else push(url);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "settings",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = push;
        $[2] = routeData.current?.routeName;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t1;
    if ($[4] !== isAdmin || $[5] !== onClick) {
        t1 = isAdmin ? (0, $9wGTI.fg)("post-office_ep_migration_inapp_715_nav4") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $mghzX.PostOfficeHtmlTarget), {
            id: "ep-migration-inapp-715-target"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xVAL.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5f8faa2e47e4a6d0$var$i18n.settings)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9xVAL.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5f8faa2e47e4a6d0$var$i18n.settings)
        }) : null;
        $[4] = isAdmin;
        $[5] = onClick;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
const $5f8faa2e47e4a6d0$var$i18n = (0, $cgtv4.defineMessages)({
    settings: {
        id: "app-navigation.top-navigation.settings",
        defaultMessage: "Confluence administration"
    }
});












var $41c4c = parcelRequire("41c4c");

/**
 * @generated SignedSource<<d3f89ff8d874d285cf9e4e12a48c2c8f>>
 * @relayHash 8a5f88c31eae893c420fe6862fbb6c53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3
const $9d6b1a9db83da49f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "creatorAccountIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "creatorAccountIds",
                    "variableName": "creatorAccountIds"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "TRASHED"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "PERSONAL"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8a5f88c31eae893c420fe6862fbb6c53",
            "id": "f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3",
            "metadata": {},
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "operationKind": "query",
            "text": "query AccountMenuTrashedPersonalSpacesQuery($creatorAccountIds:[String!]){spaces(type:\"PERSONAL\",creatorAccountIds:$creatorAccountIds,status:\"TRASHED\"){nodes{alias,key,id}}}"
        }
    };
}();
$9d6b1a9db83da49f$var$node.hash = "441235242490f35c2f56b55ed716011d";
var $9d6b1a9db83da49f$export$2e2bcd8739ae039 = $9d6b1a9db83da49f$var$node;






var $T1bCI = parcelRequire("T1bCI");





var $7rvPL = parcelRequire("7rvPL");


var $cv4vy = parcelRequire("cv4vy");


var $T9xHm = parcelRequire("T9xHm");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");





var $esKit = parcelRequire("esKit");


var $kRW4Y = parcelRequire("kRW4Y");


var $gqqjz = parcelRequire("gqqjz");


var $awSMG = parcelRequire("awSMG");

function $7567c74a2233d8d4$export$1fe43c489c085f15() {
    if ('indexedDB' in window && indexedDB.databases) indexedDB.databases().then((databases)=>{
        const offlineStepsDatabases = databases.filter((db)=>db.name && db.name.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)));
        offlineStepsDatabases.forEach((db)=>{
            if (!db.name) return;
            const openReq = indexedDB.open(db.name);
            openReq.onsuccess = (event)=>{
                const req = event.target;
                const idb = req.result;
                try {
                    const tx = idb.transaction([
                        'steps',
                        'meta'
                    ], 'readwrite');
                    tx.objectStore('steps').clear();
                    tx.objectStore('meta').clear();
                    tx.oncomplete = ()=>{
                        idb.close();
                    };
                    tx.onerror = ()=>{
                        idb.close();
                    };
                } catch  {
                    idb.close();
                }
            };
        });
    });
}



var $5MCqa = parcelRequire("5MCqa");





var $jEeDd = parcelRequire("jEeDd");


var $7J5Uc = parcelRequire("7J5Uc");


var $ictHB = parcelRequire("ictHB");


var $disnP = parcelRequire("disnP");





var $6mKj3 = parcelRequire("6mKj3");


var $hOfle = parcelRequire("hOfle");


var $kniSK = parcelRequire("kniSK");




const $22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery = (0, $9d6b1a9db83da49f$export$2e2bcd8739ae039);
/* Excluded web items include 'confluence.user.menu:user-favourites' (carried over from ProfileMenu)
 * as well as web items that are already supported by the platform Account Menu.
 * We are passing in an excluded list instead of an included list to avoid missing any web items.
 * Currently expected web items include the following:
 * - com.atlassian.confluence.plugins.confluence-frontend-support:adg3-give-feedback
 * - confluence.user.menu:create-personal-space
 * - confluence.user.menu:personal-space
 * - confluence.user.menu:admin-restore-personal-space
 * - com.atlassian.confluence.plugins.confluence-inline-tasks:my-tasks-menu-item
 * - confluence.user.menu:settings
 * - com.atlassian.plugins.atlassian-connect-plugin:confluence-chats-integration__profile
 * - extension points (begin with com.atlassian.plugins.atlassian-connect-plugin:connect-playground-confluence)
 */ const $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS = [
    'confluence.user.menu:user-favourites',
    'confluence.user.menu:user-profile',
    'confluence.user.menu:user-theme',
    'confluence.user.menu:logout'
];
const $22e97f2cae5620a3$var$getManageAccountUrl = (destinationAccountEmail, environment)=>{
    const loginLink = (0, $jEeDd.getLoginLink)($22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink(environment));
    return `${loginLink}&login_hint=${encodeURIComponent(destinationAccountEmail)}&prompt=none`;
};
const $22e97f2cae5620a3$var$getSwitchAccountUrl = ()=>{
    const loginLink = (0, $jEeDd.getLoginLink)();
    return `${loginLink}&prompt=select_account`;
};
const $22e97f2cae5620a3$var$manageProfileUrlSuffix = 'manage-profile/profile-and-visibility';
const $22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink = (environment)=>{
    if ((0, $T9xHm.isIsolatedCloud)()) // dynamically generate identity URL based on IC shard (defined in /confluence/next/tools/config/env/)
    return `https://${"id.atlassian.com"}/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
    else return environment === 'PRODUCTION' ? `https://id.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}` : `https://id.stg.internal.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
};
const $22e97f2cae5620a3$var$AccountMenuComponent = /*#__PURE__*/ (0, $42omo.memo)(({ user: user, webItems: webItems, webSections: webSections, dialogFn: dialogFn, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const getThemePreference = (0, $42omo.useCallback)(()=>(0, $ictHB.fetchGlobalColorMode)(user?.id), [
        user?.id
    ]);
    const [globalColorMode, loadGlobalColorModeOnce] = (0, $disnP.useColorModeState)(getThemePreference, user?.id);
    const userId = user?.id || '';
    const profileIconUrl = user?.photos?.[0]?.value || '';
    const accountEmail = user?.emails?.[0]?.value || '';
    const accountDisplayName = user?.displayName || '';
    const manageAccountUrl = $22e97f2cae5620a3$var$getManageAccountUrl(accountEmail, environment);
    const switchAccountUrl = $22e97f2cae5620a3$var$getSwitchAccountUrl();
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    const persistentUpgradeMenuSection = (0, $esKit.usePersistentUpgradeMenuSection)();
    const standardToPremiumEASection = (0, $c5zvz.useConfluenceStandardToPremiumPUBTouchpoint)('nav4');
    const [itemSelected, setItemSelected] = (0, $42omo.useState)(undefined);
    // if webItems has 'admin-restore-personal-space', then we need to call the query to get the trashed personal space data
    const hasTrashedPersonalSpace = webItems.some((obj)=>obj.completeKey === 'confluence.user.menu:admin-restore-personal-space');
    const { data: data } = (0, $jMyy4.useQueryInterop)($22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery, {
        skip: !hasTrashedPersonalSpace,
        variables: {
            creatorAccountIds: [
                userId || ''
            ]
        }
    });
    const node = data?.spaces?.nodes?.[0];
    const spaceKey = node?.key || '';
    const spaceId = node?.id || '';
    const spaceAlias = node?.alias || '';
    const { handleRestoreClick: handleRestoreClick } = (0, $5MCqa.useTrashedSpace)({
        spaceKey: spaceKey,
        spaceAlias: spaceAlias,
        spaceId: spaceId,
        flags: flags,
        source: 'profileMenu'
    });
    const callbackActions = {
        'user-theme': ()=>{
            itemSelected === 'user-theme' ? setItemSelected(undefined) : setItemSelected('user-theme');
        },
        'admin-restore-personal-space': ()=>handleRestoreClick()
    };
    const menuItems = (0, $hOfle.useWebItemMapper)(webItems, webSections, {
        userId: userId,
        callbackActions: callbackActions
    });
    const accountMenuItems = [
        ...persistentUpgradeMenuSection,
        ...standardToPremiumEASection,
        ...menuItems
    ];
    const getSectionTitle = (group)=>{
        if (group.heading) {
            if (typeof group.heading === 'string') return group.heading;
            else return formatMessage(group.heading);
        } else return undefined;
    };
    const onLogoutClickCallback = (_event, _analyticsEvent)=>{
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) (0, $7567c74a2233d8d4$export$1fe43c489c085f15)();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cv4vy.AccountMenuNav3), {
        globalColorMode: (0, $9wGTI.fg)('shared-user-preferences') ? globalColorMode : undefined,
        onThemeSwitcherOpenChange: loadGlobalColorModeOnce,
        testId: "confluence-account-menu",
        name: accountDisplayName,
        picture: profileIconUrl,
        trustPicture: true,
        email: accountEmail,
        viewProfileLink: "/wiki/users/viewmyprofile.action",
        manageProfileLink: manageAccountUrl,
        logOutLink: "/wiki/logout.action",
        currentTheme: themeState?.theme?.colorMode,
        onThemeChange: themingActions.setColorModePreference,
        switchAccountLink: switchAccountUrl,
        onLogoutClick: onLogoutClickCallback,
        extraMenuItems: accountMenuItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rvPL.default), {
                key: getSectionTitle(group),
                hasSeparator: true,
                title: getSectionTitle(group)
            }, group.items.map((item)=>{
                const itemGetDialog = item.hasOwnProperty('getDialog') ? item.getDialog : null;
                const dialogHandler = itemGetDialog ? ()=>{
                    dialogFn(itemGetDialog);
                } : null;
                const onClick = item.action || dialogHandler;
                const closeAction = item.closeAction;
                const onClickHandler = ()=>{
                    if (closeAction) closeAction();
                    if (onClick) onClick();
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kniSK.PopupMenuItemComponent), {
                    key: item.key,
                    item: item,
                    onClickHandler: onClickHandler,
                    closeMenu: closeAction || (()=>{}),
                    isSelected: itemSelected === item.key
                });
            })))
    });
});
const $22e97f2cae5620a3$export$ff20d75d5eda4388 = /*#__PURE__*/ (0, $42omo.memo)(({ user: user, dialogFn: dialogFn })=>{
    const { webItems: webItems, webSections: webSections } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER),
        notAllowedWebItems: $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (dialogs, flags)=>{
        const accountMenuProps = {
            user: user,
            dialogFn: dialogFn,
            webItems: webItems,
            webSections: webSections,
            dialogs: dialogs,
            flags: flags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22e97f2cae5620a3$var$AccountMenuComponent, accountMenuProps));
    });
});


const $e40e4f4e333d3274$export$6d6e8f8ac62271dd = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { user: user } = t0;
    const [activeDialog, setActiveDialog] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setActiveDialog(null);
        };
        $[0] = t1;
    } else t1 = $[0];
    const closeDialog = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[1] = t2;
    } else t2 = $[1];
    const openDialog = t2;
    const preloadMenu = $e40e4f4e333d3274$var$_temp;
    const t3 = user.id ?? null;
    const t4 = user.displayName ?? null;
    let t5;
    if ($[2] !== user.emails) {
        t5 = user.emails?.map($e40e4f4e333d3274$var$_temp2) || null;
        $[2] = user.emails;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== user.photos) {
        t6 = user.photos?.map($e40e4f4e333d3274$var$_temp3) || null;
        $[4] = user.photos;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
        t7 = {
            id: t3,
            displayName: t4,
            emails: t5,
            photos: t6
        };
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const accountMenuUser = t7;
    let t8;
    if ($[11] !== accountMenuUser) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22e97f2cae5620a3$export$ff20d75d5eda4388), {
            user: accountMenuUser,
            dialogFn: openDialog
        }));
        $[11] = accountMenuUser;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== activeDialog) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, activeDialog);
        $[13] = activeDialog;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
};
function $e40e4f4e333d3274$var$_temp() {
    (0, $41c4c.preloadProfileMenu)();
}
function $e40e4f4e333d3274$var$_temp2(email) {
    return {
        value: email?.value || null
    };
}
function $e40e4f4e333d3274$var$_temp3(photo) {
    return {
        value: photo?.value || null
    };
}



var $3yPEN = parcelRequire("3yPEN");


var $kBOGD = parcelRequire("kBOGD");


var $eDVeb = parcelRequire("eDVeb");


var $cAMBp = parcelRequire("cAMBp");

const $d7fa51f310118f21$var$TopNavigationQuery = (0, $hAiCi.default);
const $d7fa51f310118f21$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $d7fa51f310118f21$export$8a421bddecb2bf5b = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d7fa51f310118f21$var$TopNavigationQuery);
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    if (loading) return null;
    let t1;
    if ($[0] !== customTheme || $[1] !== data || $[2] !== defaultCollapsed || $[3] !== isNav4CollapseReminderSpotlightActive || $[4] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7fa51f310118f21$var$TopNavigationInner, {
            data: data,
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[0] = customTheme;
        $[1] = data;
        $[2] = defaultCollapsed;
        $[3] = isNav4CollapseReminderSpotlightActive;
        $[4] = setIsNav4CollapseReminderSpotlightActive;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== error) {
        t2 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[6] = error;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
};
const $d7fa51f310118f21$var$isAtlassianStaff = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
const $d7fa51f310118f21$var$TopNavigationInner = ({ data: data, defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    const isFhsEnabled = (0, $9wGTI.fg)('navx-2733-convert-confluence-fhs-rollout') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8zs3p.useIsFhsEnabled)() : (0, $9wGTI.fg)('navx-full-height-sidebar');
    const { isLoggedIn: isLoggedIn, cloudId: cloudId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isAtlassianStaffMemoized = (0, $42omo.useMemo)(()=>$d7fa51f310118f21$var$isAtlassianStaff(data), [
        data
    ]);
    const { uuid: uuid, isInitial: isInitial } = (0, $78QFu.getUniquePageLoadId)();
    const hasCustomTheme = !!customTheme?.highlightColor || !!customTheme?.backgroundColor;
    const [customLogoSize, setCustomLogoSize] = (0, $42omo.useState)(null);
    const handleOnLoadCustomLogo = (0, $42omo.useCallback)((event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setCustomLogoSize({
            width: naturalWidth,
            height: naturalHeight
        });
    }, []);
    (0, $42omo.useEffect)(()=>{
        // see: https://hello.jira.atlassian.cloud/browse/NAVX-2056
        if (data && isInitial && uuid) {
            const hasCustomSiteTitle = !!data.siteSettings?.showApplicationTitle && !!data.siteSettings?.siteTitle;
            const hasCustomLogo = !!data.siteConfiguration?.customSiteLogo && !!data.siteDescription?.logoUrl;
            // If there is a custom logo, but we haven't captured its size, do not log the event yet, otherwise continue
            if (hasCustomLogo && !customLogoSize) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'globalNavigation',
                    action: 'viewed',
                    actionSubject: 'topNav',
                    actionSubjectId: 'customTheme',
                    attributes: {
                        cloudId: cloudId,
                        hasCustomLogo: hasCustomLogo,
                        hasCustomSiteTitle: hasCustomSiteTitle,
                        hasCustomHighlightColor: !!customTheme?.highlightColor,
                        hasCustomBGColor: !!customTheme?.backgroundColor,
                        ...hasCustomLogo && customLogoSize ? customLogoSize : undefined,
                        ...hasCustomSiteTitle && {
                            customSiteTitleLength: data.siteSettings?.siteTitle.length
                        }
                    }
                }
            }).fire();
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        customLogoSize,
        data,
        isInitial,
        customTheme,
        uuid
    ]);
    const getShortcutVisualizer = (0, $42omo.useCallback)((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            contentBefore: label,
            shortcut: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            isEditorShortcut: isOnEditRoute,
            isTooltip: true
        }), [
        isOnEditRoute
    ]);
    const { exitMultiSelect: exitMultiSelect } = (0, $bwL2u.useContentTreeSelectionActions)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const handleMultiSelectOnCollapse = (0, $42omo.useCallback)(()=>{
        if (isMultiSelectActive) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'globalNavigation',
                    action: 'closed',
                    actionSubject: 'bulkActionsMenu',
                    attributes: {
                        method: 'collapseSideNavButton'
                    }
                }
            }).fire();
            exitMultiSelect();
        }
    }, [
        isMultiSelectActive,
        exitMultiSelect,
        createAnalyticsEvent
    ]);
    const sideNavToggleButtonComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $31c01975bf558c1d$export$8bd77667631fec25), {
        defaultCollapsed: isFhsEnabled ? undefined : defaultCollapsed,
        collapseLabel: isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel)),
        expandLabel: isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel)),
        onClick: handleMultiSelectOnCollapse
    });
    const shouldShowNewSpotlight = isNav4CollapseReminderSpotlightActive && (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration');
    const sideNavToggleButton = shouldShowNewSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0356f01208b13d1$export$6cddb4d20889bca4), {
        isVisible: !!isNav4CollapseReminderSpotlightActive,
        setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
    }, sideNavToggleButtonComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "nav4-spotlight-1"
    }, sideNavToggleButtonComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vGun.TopNavStart), {
        sideNavToggleButton: sideNavToggleButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eBBZq.AppSwitcherButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1B659.DeveloperButtons), {
        isAtlassianStaff: isAtlassianStaffMemoized
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $760ef9e13b699b30$export$48df75a983e1f3fb), {
        siteConfiguration: data?.siteConfiguration,
        siteSettings: data?.siteSettings,
        siteDescription: data?.siteDescription,
        onLoadCustomLogo: handleOnLoadCustomLogo
    }), data?.siteSettings?.showApplicationTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1eDr.CustomTitle), null, data?.siteSettings.siteTitle) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $idPUB.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eDVeb.SearchBar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kBOGD.CreateComponent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dTIqH.TopNavEnd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $XLQOT.EditionAwareness), null), (0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5zvz.EditionAwarenessUpsellExperiment), {
        navVersion: "nav4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cAMBp.RovoButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MAeh.NotificationsButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48d2632049a03f8d$export$78bddedbcf2939ac), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5f8faa2e47e4a6d0$export$e2457e1974c298c3), null), isLoggedIn && data?.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d7fa51f310118f21$var$RemovedSpotlightTarget, {
        name: "nav-profile"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e40e4f4e333d3274$export$6d6e8f8ac62271dd), {
        user: data.user
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3yPEN.LoginButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE),
        attributes: {
            navVersion: '4'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC),
        customData: {
            isAnonymous: !isLoggedIn,
            isLicensed: isLicensed,
            hasCustomTheme: hasCustomTheme
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading",
        includeFeatureFlags: true,
        details: $d7fa51f310118f21$var$nav4Details
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationFMP),
        subjectId: "NavigationFMP",
        includeFeatureFlags: true,
        details: $d7fa51f310118f21$var$nav4Details
    }));
};
const $d7fa51f310118f21$var$i18n = (0, $cgtv4.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-collapse-label",
        defaultMessage: "Collapse sidebar"
    },
    sideNavToggleButtonExpandLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-expand-label",
        defaultMessage: "Expand sidebar"
    }
});
const $d7fa51f310118f21$var$nav4Details = {
    navVersion: '4'
};


const $d782f4c4ad49c391$export$eff75454f2208b30 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            errorBoundaryId: "TopNavigation"
        };
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== customTheme || $[3] !== defaultCollapsed || $[4] !== isNav4CollapseReminderSpotlightActive || $[5] !== setIsNav4CollapseReminderSpotlightActive) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t1
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7fa51f310118f21$export$8a421bddecb2bf5b), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        }));
        $[2] = customTheme;
        $[3] = defaultCollapsed;
        $[4] = isNav4CollapseReminderSpotlightActive;
        $[5] = setIsNav4CollapseReminderSpotlightActive;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};






var $j5cB3 = parcelRequire("j5cB3");


var $ih4dR = parcelRequire("ih4dR");

const $a61833f951c42c7b$export$c0c5f5b297b77726 = (backgroundColorRaw, highlightColorRaw)=>{
    const $ = (0, $frIzR.c)(4);
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    let t0;
    if ($[0] !== backgroundColorRaw || $[1] !== highlightColorRaw || $[2] !== isDarkMode) {
        t0 = (0, $ih4dR.getCustomTheme)({
            backgroundColorRaw: backgroundColorRaw,
            highlightColorRaw: highlightColorRaw,
            isDarkMode: isDarkMode
        });
        $[0] = backgroundColorRaw;
        $[1] = highlightColorRaw;
        $[2] = isDarkMode;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};






var $hayzU = parcelRequire("hayzU");


var $emNvf = parcelRequire("emNvf");




const $f06013f8e99ab858$export$41d0d88a6b0e456f = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { defaultCollapsed: defaultCollapsed, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive } = t0;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $emNvf.default));
    const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
    const customTheme = (0, $a61833f951c42c7b$export$c0c5f5b297b77726)(horizontalHeader?.backgroundColor, horizontalHeader?.primaryNavigation?.highlightColor);
    let t1;
    if ($[0] !== customTheme || $[1] !== defaultCollapsed || $[2] !== isNav4CollapseReminderSpotlightActive || $[3] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d782f4c4ad49c391$export$eff75454f2208b30), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        });
        $[0] = customTheme;
        $[1] = defaultCollapsed;
        $[2] = isNav4CollapseReminderSpotlightActive;
        $[3] = setIsNav4CollapseReminderSpotlightActive;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hayzU.LazyImpersonationFlag), null);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "top-nav"
        }, t1, t2);
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== error) {
        t4 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[8] = error;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== customTheme || $[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hsPNq.TopNav), {
            testId: "grid-topNav",
            UNSAFE_theme: customTheme
        }, t3, t4);
        $[10] = customTheme;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
module.exports["TopNav"] = $f06013f8e99ab858$export$41d0d88a6b0e456f;

});

parcelRegister("6IkrI", function(module, exports) {

let $4e36b64b46714c38$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e36b64b46714c38$var$load("SepNY").then(()=>parcelRequire('1FDBc'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});


//# sourceMappingURL=PageLayout.2bd71ca9.js.map
